<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">门店管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>启用状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!--          <div class="content-input-item">-->
            <!--            <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
            <!--          </div>-->
            <div class="content-input-item">
              <label>门店名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editShopDialog(-1)" size="default">添加门店</el-button>
            <el-button type="warning" @click="editSysWechatDialog()" size="default">总部微信</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="" label="门店照片" v-if="checkColList.indexOf('门店照片') > -1" width="110">
              <template #default="scope">
                <div v-if="scope.row.img" @click="addShopImg(scope.row)">
                  <el-image class="item-img" fit="cover" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <div class="add" @click="addShopImg(scope.row)"><span>+</span></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="店铺名称" v-if="checkColList.indexOf('店铺名称') > -1"/>
            <el-table-column property="wechat" label="门店微信" v-if="checkColList.indexOf('门店微信') > -1"/>
            <el-table-column property="" label="门店微信二维码" v-if="checkColList.indexOf('门店微信二维码') > -1" width="130">
              <template #default="scope">
                <div v-if="scope.row.wechatImg">
                  <el-image class="item-img" fit="fill" :src="scope.row.wechatImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="addr" label="门店地址" v-if="checkColList.indexOf('门店地址') > -1"/>
            <el-table-column property="location" label="地图定位" v-if="checkColList.indexOf('地图定位') > -1"/>
            <el-table-column property="district" label="所在区域" v-if="checkColList.indexOf('所在区域') > -1"/>
            <el-table-column property="contact" label="联系方式" v-if="checkColList.indexOf('联系方式') > -1"/>
            <el-table-column property="name" label="预约时间范围" v-if="checkColList.indexOf('预约时间范围') > -1" width="120">
              <template #default="scope">
                <p>{{scope.row.startTime + '-' + scope.row.endTime}}</p>
              </template>
            </el-table-column>
            <el-table-column property="name" label="营业时间" v-if="checkColList.indexOf('营业时间') > -1" width="210">
              <template #default="scope">
                <el-space wrap v-if="scope.row.businessHoursList.length > 0" @click="editBusinessHours(scope.$index, scope.row)" class="cursor">
                  <el-tag v-for="item in scope.row.businessHoursList" :key="item.id" size="small" type="info">
                    <span>{{item.startNum == 1?'周一':item.startNum == 2?'周二':item.startNum == 3?'周三':item.startNum == 4?'周四':item.startNum == 5?'周五':item.startNum == 6?'周六':item.startNum == 7?'周日':item.startNum == 8?'节假日':''}}</span>
                    <span v-if="item.endNum < 8">到{{item.endNum == 1?'周一':item.endNum == 2?'周二':item.endNum == 3?'周三':item.endNum == 4?'周四':item.endNum == 5?'周五':item.endNum == 6?'周六':item.endNum == 7?'周日':item.endNum == 8?'节假日':''}}</span>
                    ：
                    <span>{{item.startTime}} ~ {{item.endTime}}</span>
                  </el-tag>
                </el-space>
                <el-button v-else size="small" @click="editBusinessHours(scope.$index, scope.row)">添加</el-button>
              </template>
            </el-table-column>
            <el-table-column property="shopManager" label="负责人" v-if="checkColList.indexOf('负责人') > -1"/>
            <el-table-column property="appletOpenTime" label="小程序启用时间" v-if="checkColList.indexOf('小程序启用时间') > -1" width="130"/>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
                <p :style="{color: scope.row.openState == 0?'red':''}">{{scope.row.openState == 0?'未公开':scope.row.openState == 1?'公开':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="140">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="editShopDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">开启</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getAllShopList, getShopPageList, updateShopState, getSysWechat} from "@/api/url";
import shopDialog from "./components/shopDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import SysWechatDialog from "@/views/shop/components/SysWechatDialog";
import shopTimeDialog from "@/views/shop/components/shopTimeDialog";
import shopImgDialog from "@/views/shop/components/shopImgDialog";

export default {
  name: "Shop",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['创建时间', '门店照片', '店铺名称', '门店微信', '门店微信二维码', '门店地址', '地图定位', '所在区域', '联系方式', '预约时间范围', '营业时间', '负责人', '小程序启用时间', '状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      wechatForm: {},

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editShopDialog(idx, row) {
      let _title = '';
      let shopForm = {}
      if (idx > -1) {
        _title = '编辑门店'
        shopForm = Object.assign({}, row);
        // console.log(shopForm)
      }else {
        _title = '添加门店'
        // console.log(shopForm)
      }
      Dialog.open({
        title: _title,
        component: shopDialog,
        data: {
          shopForm: shopForm,
          ids: idx,
          width: '600px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    editBusinessHours(idx, row) {
      let businessForm = {}
      businessForm = Object.assign({}, row);
      Dialog.open({
        title: '营业时间',
        component: shopTimeDialog,
        data: {
          businessForm: businessForm,
          width: '640px',
        },
        close: (result) => {
          this.getPage()
        }
      })
    },


    // getShopList() {
    //   getFormData(getAllShopList).then(data=> {
    //     data.data.map((item) => {
    //       if(item.id != 0) {
    //         this.shopIdArr.push(item)
    //       }
    //       this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
    //     })
    //   })
    // }


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateShopState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    editSysWechatDialog() {
      Dialog.open({
        title: '总部微信',
        component: SysWechatDialog,
        data: {
          wechatForm: this.wechatForm,
          width: '600px',
          type: 1,
        },
        confirm: (result) => {
          this.getSysWechat()
        }
      })
    },

    getSysWechat() {
      getFormData(getSysWechat, {type: 1}).then(data => {
          this.wechatForm = data.data
      })
    },

    addShopImg(row) {
      Dialog.open({
        title: '门店照片',
        component: shopImgDialog,
        data: {
          shopForm: row,
          width: '400px',
        },
        confirm: (result) => {
          row.img = result
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getSysWechat()
    // this.getShopList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 24px;
  cursor: pointer;
  margin: 0 auto
}
</style>
